export interface Breadcrumb {
  current: string
  url: string
  hierarchies: Hierarchy[]
}
export interface Hierarchy {
  title: string
  link?: string
}

export interface Category {
  id?: string | null
  title?: string | null
  parent?: string | null
  isParent?: boolean | null
  sub?: Array<Category | null> | null
  tags?: Array<string | null> | null
}

export type BreadcrumbType = 'breadcrumb' | 'breadcrumbAll' | 'tag'

export function toTopBreadcrumbs(
  hierarchies: Hierarchy[],
  current: string,
  topTitle: string
): Required<Hierarchy>[] {
  return [
    { title: topTitle, link: '/' },
    ...(hierarchies || [])
      .filter(({ title }) => title)
      .map(link => ({ ...link, link: link.link || '/' })),
    { title: current, link: '' },
  ]
}

function findCategoryById(id: string, categories: Category[]): Category | undefined {
  return categories.find(category => category.id === id)
}

function buildBreadcrumbs(
  category: Category,
  categories: Category[],
  hierarchies: Required<Hierarchy>[]
): Required<Hierarchy>[] {
  const breadcrumbs = [...hierarchies]
  const parents = []
  let currentCategory = category

  while (currentCategory.parent) {
    const parentCategory = findCategoryById(currentCategory.parent, categories)
    if (!parentCategory) break
    parents.unshift({
      title: parentCategory.title || '',
      link: `/category/${parentCategory.id}`,
    })
    currentCategory = parentCategory
  }

  breadcrumbs.splice(1, 0, ...parents)
  breadcrumbs.splice(1 + parents.length, 0, {
    title: category.title || '',
    link: `/category/${category.id}`,
  })

  return breadcrumbs
}

export function toAllBreadcrumbs(
  hierarchies: Required<Hierarchy>[],
  relatedCategories: Category[]
): Required<Hierarchy>[][] {
  if (!relatedCategories || relatedCategories.length === 0) {
    return [hierarchies]
  }

  const result: Required<Hierarchy>[][] = []

  relatedCategories.forEach(category => {
    if (!category.isParent) {
      const newHierarchies = buildBreadcrumbs(category, relatedCategories, hierarchies)
      result.push(newHierarchies)
    }
  })

  return result
}
